import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'questionnaire-cell-renderer',
  standalone: true,
  imports: [NgIf],
  template: `
    <div *ngIf="value" class="tag {{ value?.questionnaire_name + 'Tag' }}">
      <span>{{ value?.questionnaire_name?.toUpperCase() }} #{{ value?.qnr_position}}</span>
    </div>
  `,
  styles: [
    `
      :host {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
      span {
        text-align: center;
        width: 100%;
      }
      .tag {
        padding: 6px 14px;
        border-radius: 6px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        font-weight: 500;
        display: flex;
        align-items: center;
        height: 24px;
        font-size: 13px;
        text-transform: capitalize;
        min-width: 80px;
        text-align: center;
        color: black;
      }
      .InitialTag {
        border: 2px solid #565B3A;
      }
      .Follow-UpTag {
        border: 2px solid #D7C8D7;
      }
      .AthletesTag {
        border: 2px solid #3B3128;
      }
    `,
  ],
})
export class QuestionnaireRendererComponent implements ICellRendererAngularComp {
  public value?: any;

  agInit(params: ICellRendererParams): void {
    this.value = params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.value;
    return true;
  }
}